import { render } from "./pricing.html?vue&type=template&id=6ebedf16&external"
import script from "./pricing.js?vue&type=script&lang=js&external"
export * from "./pricing.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__